'use strict';

SelectionTabController.$inject = [
	'mx.SolutionBuilderAgent.SelectionGrid',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'$scope',
	'$q',
	'mx.shell.KeyboardNavigationService',
	'mx.internationalization',
	'mx.SolutionBuilderAgent.MxGridHelperService',
	'mx.shell.EventService',
];
export default function SelectionTabController(SelectionGrid, dialogOpenerService, $scope, $q, keyboardNavigationService, i18n, gridHelperService, eventService) {
	const vm = this;
	vm.gridHelperService = gridHelperService;

	let selectedType,
		resetFilter = false;

	Object.defineProperty(vm, 'selectedType', {
		get: function () {
			return selectedType;
		},
		set: function (newType) {
			selectedType = newType;
			if (selectedType) {
				vm.grid.allowedTypes = vm.selectedType;
				vm.grid.executor.loadItems();
			} else {
				vm.grid.executor.dataItems = [];
			}
		},
	});

	Object.defineProperty(vm, 'resetFilter', {
		get: function () {
			return resetFilter;
		},
		set: function (newValue) {
			if (resetFilter !== newValue) {
				resetFilter = newValue;
				vm.grid.executor.updateRequestOptions({
					filter: resetFilter ? vm.resetFilterExpression : vm.filter,
					resetFilter: resetFilter,
				});
				vm.grid.executor.loadItems();
			}
		},
	});

	vm.$onInit = function () {
		const grid = new SelectionGrid();

		vm.view = $scope.$parent.vm.mxView;

		registerHotkeys();
		angular.extend(grid, {
			entityClassName: this.entityClassName,
			relation: this.relation,
			invertRelation: this.invertRelation,
			archived: this.archived,
			objectIDs: this.objectIDs,
			useObjectId: this.useObjectId,
			excludedIDs: this.excludedIDs,
			allowedTypes: this.allowedTypes,
			filter: this.filter,
			correctEntityFilter: this.correctEntityFilter,
			columnDefinition: this.columnDefinition,
			parentView: this.view,
			presetFields: this.presetFields,
			showActionsPanel: this.showActionsPanel,
			showSelectAll: this.showSelectAll,
			createButtonHidden: Boolean(vm.viewMode || vm.createButtonHidden),
			addButtonHidden: true,
			removeButtonHidden: true,
			enableAdvanceSearch: true,

			onClick: onGridClick,
			onDblClick: onGridDblClick,
		});

		vm.grid = grid;

		vm.fullHeightOptions = vm.viewMode
			? {
					layoutBottomOffset: 0,
					dialogButtonsOffset: 0,
			  }
			: true;

		let promise;
		if (vm.onlyTypedSelectSearch) {
			promise = vm.gridHelperService.getAllowedEntityTypes(grid.entityClassName, vm.allowedTypes).then(function (entityTypes) {
				if (typeof vm.allowedTypes === 'string' && vm.allowedTypes.length) {
					entityTypes.sort(function (a, b) {
						const diff = vm.allowedTypes.indexOf(a.Name) - vm.allowedTypes.indexOf(b.Name);
						return diff > 0 ? 1 : diff < 0 ? -1 : 0;
					});
				}

				vm.allowedEntityTypeItems = entityTypes;

				if (entityTypes.length > 0) {
					selectedType = entityTypes[0].Name;
					grid.allowedTypes = selectedType;
				}
			});
		} else {
			promise = $q.resolve();
		}

		promise
			.then(function () {
				const personalizationKey = grid.columnDefinition || grid.entityClassName;
				return grid.init(personalizationKey);
			})
			.then(function () {
				grid.executor.addSelectionHandler(selectionHandler);
			});
	};

	vm.select = select;
	vm.cancel = cancel;

	function onGridClick(row) {
		if (vm.viewMode) {
			vm.grid.runGenericPreview(row.getEntity());
		} else {
			vm.grid.executor.toggleRowSelection(row);
		}
	}

	function onGridDblClick(row) {
		if (vm.viewMode) {
			vm.grid.editRow(row).catch(mx.logCatch);
		} else {
			vm.grid.executor.selectRow(row);
			select();
		}
	}

	function selectionHandler(data) {
		if (!vm.multiSelection && data.allSelectedRows.length) {
			select();
		}
		eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged);
	}

	function select() {
		vm.finishDefer.resolve(vm.grid.executor.allSelectedEntities);
	}

	function cancel() {
		vm.finishDefer.reject(mx.noLogCatchMessage('multi-selection tab was canceled'));
	}

	function registerHotkeys() {
		keyboardNavigationService.registerKey({
			scope: $scope,
			nameInTemplate: 'hintKey',
			key: 'alt+z',
			description: i18n.get('solutionBuilderAgent.layouts.multiselection-tab.cancel'),
			callback: cancel.bind(vm),
		});
	}
}
